module.exports = __webpack_public_path__ + "static/media/brush-paradiso-3.d736d7d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/images/brush-paradiso-3.png
// module id = 530
// module chunks = 0